

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import 'vant/lib/index.css';
import { delNullProperty } from "@/utils/index";
import axios from "axios";

@Component({
})
export default class Home extends Vue {
    @Prop({default: () => ([]) }) liData!: Array<any>;
    // @Prop({default: false}) show!: Boolean;
    // @Prop({default: false}) search!: Boolean;

    private checkedData = [] //选中的数据
    private isShow = false //下拉列表是否显示
    private selectCon = '' //选中的内容

    created(){
      console.log(this.liData)
    }

    //控制下拉列表的显示隐藏
    liShow() {
      // this.isShow = true
      // console.log('点击',this.selectCon)
      //选中数据
      // this.checkedData = this.liData.filter(function(item) {
      //   return item.Check == true;
      // });
      // console.log(this.checkedData)
      // // //在页面打印出的数据
      // this.selectCon = ""; //点击的当前项的展示
      // for (var i = 0; i < this.checkedData.length; i++) {
      //   this.selectCon += this.checkedData[i].Name + "  ";
      // }
      // console.log(this.selectCon)
      // // this.$emit("update:show", this.selectCon)
      // // 给父组件传值
      // this.$emit("change", this.selectCon)
    }

    mounted() {
      //点击页面空白处隐藏下拉列表
      // document.addEventListener("click", function() {
      //   this.isShow = false
      // })
    }


    @Watch('liData')
    handler() {
      console.log(this.liData)

      // //选中数据
      // this.checkedData = newVal.filter(function(item) {
      //   return item.Check == true;
      // });
      // // //在页面打印出的数据
      // this.selectCon = ""; //点击的当前项的展示
      // for (var i = 0; i < this.checkedData.length; i++) {
      //   this.selectCon += this.checkedData[i].Name + "  ";
      // }
      // // this.$emit("update:show", this.selectCon)
      // // 给父组件传值
      // this.$emit("change", this.selectCon)

    }
}
